import React, { useState, useEffect, useCallback, useRef } from "react";

//routing
import {  useParams, useSearchParams } from "react-router-dom";
//components
import DataTable from "../../../../components/Tables/DataTable";
import PaperComponent from "../../../../components/Modal/PaperComponent";

//hooks
import useLazyQueryAuth from "../../../../hooks/useLazyQueryAuth";
import useQueryAuth from "../../../../hooks/useQueryAuth";
import useAuth from "../../../../hooks/useAuth";
import useMutationAuth from "../../../../hooks/useMutationAuth";

//graphql
import { GET_USER_TABLE_PREFERENCES } from "../../../../graphql/userTablePreferences";
import {
  GET_TIME_ENTRIES,
  DELETE_TIME_ENTRY_LIST,
  GET_ALL_TIME_ENTRIES_STATUS,
  UPDATE_TIME_ENTRY_STATUS,
} from "../../../../graphql/timeEntry";
import { GET_ALL_EMPLOYEES_DROPDOWN } from "../../../../graphql/employee";
import { GET_ALL_PROJECTS } from "../../../../graphql/project";

//editors
import { Parse } from "../../../../JSON.editor";

//mnemonic values
import Mnemonic from "../../../../Mnemonics.json";

//external components

import UTC2Local, {
  UTC2Time,
  formatDateTimeToString,
} from "../../../../UTC2Local";
import componentDisplay from "../../../../componentDisplay";
import { useSnackbar } from "notistack";

import EditRecord from "../../Timesheets/Timesheets-Form/components/EditRecord";
import TimeEntryDrawer from "../../Timesheets/Timesheets-Form/components/TimeEntryDrawer";
import { useNavigate } from "react-router-dom";

import { useTranslation } from "react-i18next";
import TaskTabsModal from "../../../../components/Modal/TaskTabsModal";
import RoundedDatePicker from "../../../../components/DateField/RoundedDatePicker";
import AutoComplete from "../../../../components/AutoComplete";

import { handleValidateDates } from "../../../../utils/functions";
import {
  ListItemIcon,
  MenuItem,
  Menu,
  Dialog,
  DialogTitle,
  DialogContent,
  IconButton,
  Grid,
  Autocomplete,
  DialogActions,
  TextField,
 
} from "@mui/material";
import {
  GetEntriesIcon,
  MoveIcon,
  ApproveTimeEntryIcon,
  RejectIcon,
} from "../../../../components/Icon";
import colors from "../../../../assets/theme/light/colors";
import AttendanceByEmployee from "../../Timesheets/MyTimesheet";
import { Title } from "../../../../components/Titles/FormTitles";
import { decodeUnicodeString } from "../../../../utils/decodeUnicodeString";
import { removeNullProps } from "../../../../utils/removeNullProps";
import Tooltip from "../../../../components/Tooltip";

import RoundedTextField from "../../../../components/TextFields/RoundedTextField";
import IALoadingButton from "../../../../components/IAButtons/IALoadingButton";
import { NextIcon, PreviousIcon } from "../../../../components/Icon";
import {
  DATE_FILTER_DATA,
  handleDateBackward,
  handleDateForward,
  handleTimeBetween,
} from "../../../../utils/period";

import MoveTimeEntryModal from "../../TimeEntries/MoveTimeEntry";
function TimeEntryRequestsList({
  fromTenant = false,
  myTime = false,
  removeHeader = false,
  removeCheckbox = false,
  taskID,
  taskName,
  projectName,
  modal,
  refetchTasks,
  selectedTask,
  handleFormChanged,
  refetchTask,
  handleFetchTree,
  changeLoadingState,
  billable,
}) {
  const { pName, tskID, tskName, eID } = useParams();
  const { dark_logo_blue } = colors;
  const { storeUserGuid, storeUserTenant,  isManager, userRoles } =
    useAuth();

  const {  manageTimeEntry } = userRoles;

  const { t } = useTranslation();

  const { enqueueSnackbar } = useSnackbar();

  const data_filter = DATE_FILTER_DATA(t);
  const [re, setRe] = useState(false);
  const [data, setData] = useState([]);
  const [filterState, setFilterState] = useState([]);

  const [anchorEl, setAnchorEl] = useState(null);
  const [timesheet, setTimesheet] = useState(false);
  const [open, setOpen] = useState(false);
  const [columns, setColumns] = useState([]);
  const [openMoveTaskDialog, setOpenMoveTaskDialog] = useState(false);
  const [order, setOrder] = useState("");
  const [orderBy, setOrderBy] = useState("");
  const [selected, setSelected] = useState([]);
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(100);
  const [search, setSearch] = useState("");
  const [clicked, setClicked] = React.useState(false);
  const [editMode, setEditMode] = React.useState(false);
  const [timeEntry, setTimeEntry] = React.useState(null);
  const [timeEntryGuid, setTimeEntryGuid] = React.useState(null);
  const [employeeGuid, setEmployeeGuid] = React.useState(null);
  const [task, setTask] = React.useState(selectedTask);
  const [resetFields, setResetFields] = React.useState(false);
  const [synced, setSynced] = React.useState(false);
  const [showModal, setShowModal] = React.useState(false);
  const [fetchProjects, setFetchProjects] = React.useState(false);

  const [fetchStatuses, setFetchStatuses] = React.useState(false);
  const [task_list, setTasksList] = React.useState([]);
  const [projectsList, setProjectsList] = React.useState([]);
  const [employeesList, setEmployeesList] = React.useState([]);
   const [button1Subitting, setButton1Submitting] = useState(false);
  const [button2Subitting, setButton2Submitting] = useState(false);
  const [button3Subitting, setButton3Submitting] = useState(false);

  const [fetchEmployees, setFetchEmployees] = useState(false);

  const type = useRef("task");

  const nowDate = new Date();

  const [selectedDate, setSelectedDate] = React.useState([]);
  const [sideInfoData, setSideInfoData] = useState({
    "Duration.todaysTotal": "0",
    "Duration.totalHours": "0",
    "Duration.weeksTotal": "0",
  });

  const firstDayOfWeek = new Date(nowDate);
  firstDayOfWeek.setDate(
    nowDate.getDate() - nowDate.getDay() + (nowDate.getDay() === 0 ? -6 : 1)
  );

  const [dateFrom, setDateFrom] = useState(null);

  const lastDayOfWeek = new Date(firstDayOfWeek);
  lastDayOfWeek.setDate(firstDayOfWeek.getDate() + 6);

  const [dateTo, setDateTo] = useState(null);
  const [projectIDs, setProjectIDs] = useState([]);
  const [employeeIDs, setEmployeeIDs] = useState([]);

  const [employeesValue, setEmployeesValue] = useState();

  const [projectsValue, setProjectsValue] = useState([]);

  const [statusesList, setStatusesList] = React.useState([]);
  const [statusesValue, setStatusesValue] = useState([]);
  const [statusIDs, setStatusIDs] = useState([]);

  const [dateVal, setDateVal] = useState(
    data_filter.find((x) => x.mnemonic === "custom")
  );
  // const [task, setTask] = React.useState(null);
  const [showConfirmationPopup, setShowConfirmationPopup] = useState(false);
  const navigate = useNavigate();
  const [menuItems, setMenuItems] = useState(null);

  const [timer, setTimer] = useState(null);
  
  const openMenuItems = Boolean(menuItems);
  
  let [searchParams, setSearchParams] = useSearchParams();

  const [defaultFilters, setDefaultFilters] = useState(null);
  const handleCloseMenu = () => {
    setMenuItems(null);
  };
  function disableDates(date) {
    const oneDayBefore = new Date(dateFrom);
    oneDayBefore.setDate(oneDayBefore?.getDate() - 1);
    return date < oneDayBefore;
  }

  const [openRejectionReason, setOpenRejectionReason] = useState(false);
  const [reason, setReason] = useState("");

  const handleSubmit = () => {
    if (reason.trim() === "") {
      enqueueSnackbar(t("timeEntry.reason.requiredMsg"), {
        variant: "error",
        autoHideDuration: 5000,
      });
      return;
    }
    EditTimeEntryStatusData(rejectedStatusGuid, reason);
    setOpenRejectionReason(false);
    setReason("");
  };

  useEffect(() => {
    if (tskID != null && pName != null && tskName != null)
      setTask({ taskGuid: tskID, title: pName + " - " + tskName });
    if (taskID != null && taskName != null && projectName != null)
      setTask({ taskGuid: taskID, title: projectName + " - " + taskName });
  }, [tskID, tskName, taskID, taskName]);

  useEffect(() => {
    if (timeEntry) setTimeEntryGuid(timeEntry.timeEntryGuid);
  }, [timeEntry]);

  useEffect(() => {
    if (selectedTask) setTask(selectedTask);
  }, [selectedTask]);
  useEffect(() => {
    console.log("Updated employeesValue:", employeesValue);
  }, [employeesValue]);


  useEffect(() => {
    if (selectedDate.length > 0) {
      const dates = selectedDate.map((date) => new Date(date));
      const earliestDate = new Date(Math.min(...dates));
      const latestDate = new Date(Math.max(...dates));
      const dateToValue = {
        value: latestDate,
        property: "dateTo",
      };

      const dateFromValue = {
        value: earliestDate,
        property: "dateFrom",
      };

      setDefaultFilters((prevFilters) => ({
        ...prevFilters,
        dateTo: latestDate.toDateString(),
        dateFrom: earliestDate.toDateString(),
      }));

      // Update filter state
      setFilterState((prevState) => [...prevState, dateToValue, dateFromValue]);
    }
  }, [selectedDate]);

  const { mfunction: deleteRecords, loading: deleteLoading } = useMutationAuth(
    DELETE_TIME_ENTRY_LIST,
    "DeleteTimeEntries"
  );
  const {
    loading: getStatusesLoading,
    tokenChange: statusesWait,
    data: statusesData,
  } = useQueryAuth(
    GET_ALL_TIME_ENTRIES_STATUS,
    "GetTimeEntriesStatus",
    {
      variables: {
        model: {
          userID: storeUserGuid,
        },
      },
      isWait: true,
    },
    {
      onCompleted: (response) => {
        setStatusesList(
          response.GetTimeEntriesStatus?.timeEntriesStatus?.filter(
            (status) =>
              status.mnemonic === "new" || status.mnemonic === "adjusted" || status.mnemonic==="rejected"
          )
        );
        setStatusIDs(
          response?.GetTimeEntriesStatus?.timeEntriesStatus
            ?.filter(
              (status) =>
                status.mnemonic === "new" || status.mnemonic === "adjusted" || status.mnemonic==="rejected"
            )
            .map((status) => status.timeEntryStatusGuid)
        );
      },
    }
  );
  
  const filteredStatusGuids =
    statusesData?.GetTimeEntriesStatus?.timeEntriesStatus
      ?.filter(
        (status) => status.mnemonic === "new" || status.mnemonic === "adjusted" || status.mnemonic==="rejected"
      )
      .map((status) => status.timeEntryStatusGuid) || [];
  const approvedStatusGuid =
    statusesData?.GetTimeEntriesStatus?.timeEntriesStatus?.find(
      (status) => status.mnemonic === "approved"
    ).timeEntryStatusGuid;
  const rejectedStatusGuid =
    statusesData?.GetTimeEntriesStatus?.timeEntriesStatus?.find(
      (status) => status.mnemonic === "rejected"
    )?.timeEntryStatusGuid || null;

  useEffect(() => {
    if (searchParams.size > 0) {
      let filterFromParams = {
        canManageTimeEntries: true,
        open: false,
        statusGuids: [searchParams.get("adjustedStatusGuid")],
      };
      fetchTableData(
        page,
        rowsPerPage,
        order,
        orderBy,
        search,
        filterFromParams
      );
    } 
    // else {
    //   fetchTableData(page, rowsPerPage, order, orderBy, search, {
    //     canManageTimeEntries: true,
    //     open: false,
    //     dateFrom: dateFrom ? new Date(dateFrom).toDateString() : null,
    //     dateTo: dateTo ? new Date(dateTo).toDateString() : null,
    //     statusGuids: statusIDs.length > 0 ? statusIDs : filteredStatusGuids,
      
    //   });
    // }
  }, []);
  const {
    loading: getColumnsLoading,
    tokenChange: columnsWait,
    refetch,
  } = useQueryAuth(
    GET_USER_TABLE_PREFERENCES,
    "GetUserTablePreferences",
    {
      variables: {
        model: {
          table:
            // myTime || eID === true
            //   ?
            Mnemonic.Tables.OpenTimeEntries,
          // : Mnemonic.Tables.TimeEntries,
          userID: storeUserGuid,
        },
      },
      isWait: true,
    },
    {
      onCompleted: (response) => {
        let col =
          response &&
          response.GetUserTablePreferences &&
          response.GetUserTablePreferences.columns
            ? response.GetUserTablePreferences.columns
            : null;

        const actions = ({ compProps }) => {
          let props = compProps;

          return (
            <EditRecord
              {...props}
              fromTimeEntryApproval={true}
              handleClick={(v) => setClicked(v)}
              handleChangeTask={(v) => setTask(v)}
              handleRowSelect={(t) => setTimeEntry(t)}
              handleEditMode={(v) => setEditMode(v)}
              handleSetSynced={(v) => setSynced(v)}
            />
          );
        };

        if (col) {
          col = decodeUnicodeString(col);

          //we parse the json string to a json object
          const parsed = JSON.parse(col, (key, value) =>
            Parse(
              key,
              value,
              UTC2Local,
              componentDisplay,
              UTC2Time,
              actions,
              null,
              formatDateTimeToString
            )
          );

          if (parsed.columns) {
            let cols = parsed.columns;

            cols.map((c) => {
              c = removeNullProps(c);
              return c;
            });
            setColumns(cols);
          }

          if (parsed.defaultSort) setOrderBy(parsed.defaultSort);

          if (parsed.defaultSortDirection)
            setOrder(parsed.defaultSortDirection);
        }
      },
    }
  );

  const {
    data: employeesData,
    mfunction: getEmployees,
    loading: employeeLoading,
    tokenChange: employeeWait,
  } = useLazyQueryAuth(GET_ALL_EMPLOYEES_DROPDOWN, "GetCompanyUsersList");

  useEffect(() => {
    if (fetchEmployees) {
      getEmployees(
        {
          variables: {
            model: {
              enableFilters: true,
              tenantID: fromTenant ? null : storeUserTenant,
              userID: storeUserGuid,
              isManagerUsersList: isManager === true ? true : null,
              timeEntryDisabled: true,
              filters: {
                fromTimeEntryApprovalPage: true,
              },
            },
          },
          skip: !fetchEmployees,
          isWait: fetchEmployees,
        },
        (response) => {
          setEmployeesList(
            response?.GetCompanyUsersList?.usersList?.employees || []
          );
        }
      );
    }
  }, [fetchEmployees]);

  const {
    data: projectsData,
    mfunction: getProjects,
    loading: projectLoading,
    tokenChange: projectsWait,
  } = useLazyQueryAuth(GET_ALL_PROJECTS, "GetAllProjects");

  useEffect(() => {
    if (fetchProjects) {
      getProjects(
        {
          variables: {
            model: {
              enableFilters: true,
              tenantID: storeUserTenant,
              userID: storeUserGuid,
              filters: {
                fromTimeEntryApprovalPage: true,
              },
            },
          },
          skip: !fetchProjects,
          isWait: fetchProjects,
        },
        (response) => {
          setProjectsList(
            response?.GetAllProjects?.projectsList?.projects || []
          );
        }
      );
    }
  }, [fetchProjects]);

  const { cfunction: editTimeEntryStatusData } = useMutationAuth(
    UPDATE_TIME_ENTRY_STATUS,
    "UpdateTimeEntryStatus"
  );

  function EditTimeEntryStatusData(statusGuid, actions) {
    setButton1Submitting(true);
    setButton2Submitting(true);
    setButton3Submitting(true);
    const formattedList = selected.map((timeEntryGuid) => ({
      timeEntryGuid,
    }));
    editTimeEntryStatusData(
      {
        variables: {
          model: {
            userID: storeUserGuid,
            updateTimeEntryStatusRequestList: formattedList,
            timeEntryStatusGuid: statusGuid,
            rejectionReason: reason,
          },
        },
      },
      (response) => {
        if (
          response["UpdateTimeEntryStatus"].errorCode !== null &&
          response["UpdateTimeEntryStatus"].errorCode !== ""
        ) {
          enqueueSnackbar(t(response["UpdateTimeEntryStatus"].errorMessage), {
            variant: "error",
            autoHideDuration: 5000,
          });
          setButton1Submitting(false);
          setButton2Submitting(false);
          setButton3Submitting(false);
        } else {
          setSelected([]);
          enqueueSnackbar(t("timeEntryForm.updatedSuccessfully"), {
            variant: "success",
          });

          if (refetchData) refetchData();
        }
        setButton1Submitting(false);
        setButton2Submitting(false);
        setButton3Submitting(false);
      },
      (error) => {
        setButton1Submitting(false);
        setButton2Submitting(false);
        setButton3Submitting(false);
      }
    );
  }

  const {
    mfunction: getAllTimeEntries,
    loading,
    refetch: refetchData,
  } = useLazyQueryAuth(GET_TIME_ENTRIES, "GetTimeEntries");

  const fetchTableData = useCallback(
    (
      page = 0,
      pageSize = 0,
      order = "",
      orderBy = "",
      search = "",
      filters = null
    ) => {
      let filter = {
        project: projectIDs.length > 0 ? projectIDs : null,
        employee: employeeIDs,
        dateFrom: dateFrom ? new Date(dateFrom).toDateString() : null,
        dateTo: dateTo ? new Date(dateTo).toDateString() : null,
        statusGuids: statusIDs.length > 0 ? statusIDs : filteredStatusGuids,
        canManageTimeEntries: true,
        open: false,
      };
      getAllTimeEntries(
        {
          variables: {
            model: {
              enableFilters: true,
              keys: {
                page: page + 1,
                pageSize: pageSize,
              },
              orderColumn: orderBy,
              orderDirection: order,
              keyWord: search,
              taskGuid: tskID ? tskID : taskID,
              userID: storeUserGuid,
              filters: filters,
            },
          },
        },
        (response) => {
          setData(response);
        }
      );
    },
    []
  );

  // useEffect(() => {
  //   const filter={
  //     project: projectIDs.length > 0 ? projectIDs : null,
  //     employee: employeeIDs,
  //     dateFrom: new Date(dateFrom).toDateString(),
  //     dateTo: new Date(dateTo).toDateString(),
  //     };
  //   if (!columnsWait && !employeeWait)
  //     fetchTableData(page, rowsPerPage, order, orderBy, search, filter);
  // }, [columnsWait, employeeWait, fetchTableData, re, projectIDs, employeeIDs, dateTo, re, dateFrom]);

  useEffect(() => {
    let filter = {
      project: projectIDs.length > 0 ? projectIDs : null,
      employee: employeeIDs,
      dateFrom: dateFrom ? new Date(dateFrom).toDateString() : null,
      dateTo: dateTo ? new Date(dateTo).toDateString() : null,
      statusGuids: statusIDs.length > 0 ? statusIDs : filteredStatusGuids,
      canManageTimeEntries: true,
      open: false,
    };

    setDefaultFilters(filter);
  }, [projectIDs, employeeIDs, dateTo, re, dateFrom, statusIDs]);
  useEffect(() => {
    console.log("Updated defaultFilters:", defaultFilters);
  }, [defaultFilters]);

  const rows =
    data &&
    data.GetTimeEntries &&
    data.GetTimeEntries.timeEntriesList &&
    data.GetTimeEntries.timeEntriesList.timeEntries
      ? data.GetTimeEntries.timeEntriesList.timeEntries
      : [];

  const numberOfRecords =
    data &&
    data.GetTimeEntries &&
    data.GetTimeEntries.timeEntriesList &&
    data.GetTimeEntries.timeEntriesList.totalNumberOfRecords
      ? data.GetTimeEntries.timeEntriesList.totalNumberOfRecords
      : 0;

  // useEffect(() => {
  //   if (rows) {
  //     setSideInfoData({
  //       "Duration.todaysTotal":
  //         data?.GetTimeEntries?.timeEntriesList?.todaysTotal === "0"
  //           ? "0"
  //           : data?.GetTimeEntries?.timeEntriesList?.todaysTotal || "0",
  //       "Duration.weeksTotal":
  //         data?.GetTimeEntries?.timeEntriesList?.weeklyTotal === "0"
  //           ? "0"
  //           : data?.GetTimeEntries?.timeEntriesList?.weeklyTotal || "0",
  //       "Duration.totalHours":
  //         data?.GetTimeEntries?.timeEntriesList?.totalHours === "0"
  //           ? "0"
  //           : data?.GetTimeEntries?.timeEntriesList?.totalHours || "0",
  //     });
  //   }
  // }, [rows]);

  const handleDeselect = () => {
    sessionStorage.removeItem("unsavedChanges");
    if (handleFormChanged !== undefined) handleFormChanged(false);
  };

  const handleDelete = () => {
    deleteRecords(
      {
        variables: {
          model: {
            timeEntryGuids: selected,
          },
        },
      },
      (response) => {
        enqueueSnackbar(t("timeEntry.list.delete.success"), {
          variant: "success",
        });
        setRe((v) => !v);
        setSelected([]);
        setPage(0);
        if (refetchTask) refetchTask();
        if (handleFetchTree) handleFetchTree();
      }
    );
  };

  useEffect(() => {
    if (selected.length > 0) handleDeselect();
  }, [selected.length]);

  const customButtons = [
    {
      label: "timeEntry.approval.Search",
      handleClick: () => {
        setSelected([]);
        if (!columnsWait && !employeeWait && !statusesWait)
          fetchTableData(
            page,
            rowsPerPage,
            order,
            orderBy,
            search,
            defaultFilters
          );
      },
      condition: true,
      icon: true,
      iconButton: <GetEntriesIcon color={dark_logo_blue} />,
    },
    {
      label: "timesheet.btn.move.timeE",
      icon: true,
      condition: selected.length !== 0,
      iconButton: <MoveIcon color={"#00000095"} />,
      handleClick: () => setOpenMoveTaskDialog(true),
    }, 
     {
      label: "timesheet.btn.approve.label",
      handleClick: () => {
        EditTimeEntryStatusData(approvedStatusGuid);
      },

      condition: selected?.length > 0,
      //    diabled:rows?.length<1||selected?.length<1,
      icon: true,
      iconButton: <ApproveTimeEntryIcon />,
    },
    {
      label: "timesheet.btn.reject.label",
      handleClick: () => {
        setOpenRejectionReason(true);
      },
      condition: selected?.length > 0,
      //diabled:rows?.length<1||selected?.length<1,
      icon: true,
      iconButton: <RejectIcon />,
    },
  
  ];

  const renderAddTime = () => {
    return (
      <Menu
        anchorEl={anchorEl}
        // className="account-menu-profile"
        MenuListProps={{ sx: { py: 0, width: "230px" } }}
        open={openMenuItems}
        onClose={handleCloseMenu}
        onClick={handleCloseMenu}
        transformOrigin={{ horizontal: "right", vertical: "top" }}
        anchorOrigin={{ horizontal: "right", vertical: "top" }}
        style={{ textAlign: "left" }}
        slotProps={{
          paper: {
            sx: {
              backgroundColor: "white !important",
              top: "9rem !important",
              boxShadow: `${colors.box_shadow_color} 1.95px 1.95px 2.6px !important`,
            },
          },
        }}
      >
        <div
          // className="suggestionsMenu"
          style={{
            textAlign: "left",
            backgroundColor: `${colors.grey_background} !important`,
          }}
        >
          <div style={{ display: "flex", flexDirection: "column" }}>
            <MenuItem
              className="user-menu-item-hover"
              style={{ paddingTop: "20px" }}
              onClick={() => {
                handleAddTimeEntry();
              }}
            >
              <ListItemIcon>
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  className="icon icon-tabler icon-tabler-alarm"
                  width="20"
                  height="20"
                  viewBox="0 0 24 24"
                  strokeWidth="1"
                  stroke="#000000"
                  fill="none"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                >
                  <path stroke="none" d="M0 0h24v24H0z" fill="none" />
                  <path d="M12 13m-7 0a7 7 0 1 0 14 0a7 7 0 1 0 -14 0" />
                  <path d="M12 10l0 3l2 0" />
                  <path d="M7 4l-2.75 2" />
                  <path d="M17 4l2.75 2" />
                </svg>
              </ListItemIcon>
              <span style={{ fontSize: "13px", fontFamily: "Poppins" }}>
                {t("ts.AddtimeEntry")}
              </span>
            </MenuItem>
            <MenuItem
              className="user-menu-item-hover"
              onClick={handleAddTimesheet}
            >
              <ListItemIcon>
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  className="icon icon-tabler icon-tabler-chart-infographic"
                  width="20"
                  height="20"
                  viewBox="0 0 24 24"
                  strokeWidth="1"
                  stroke="#000000"
                  fill="none"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                >
                  <path stroke="none" d="M0 0h24v24H0z" fill="none" />
                  <path d="M7 7m-4 0a4 4 0 1 0 8 0a4 4 0 1 0 -8 0" />
                  <path d="M7 3v4h4" />
                  <path d="M9 17l0 4" />
                  <path d="M17 14l0 7" />
                  <path d="M13 13l0 8" />
                  <path d="M21 12l0 9" />
                </svg>
              </ListItemIcon>
              <span
                style={{
                  fontSize: "13px",
                  fontFamily: "Poppins",
                  marginTop: "5px",
                }}
              >
                {t("ts.addtimesheet")}
              </span>
            </MenuItem>
          </div>
        </div>
      </Menu>
    );
  };

  const handleAddTimesheet = () => {
    // navigate(my_timesheet);
    setTimesheet(true);
  };
  const handleCloseTimesheet = () => {
    setTimesheet(false);
    setSelectedDate([new Date()]);
    refetchData();
  };

  const handleCloseSubmitTimesheet = () => {
    setTimesheet(false);
    refetchData();
  };

  const handleAddTimeEntry = () => {
    if (JSON.parse(sessionStorage.getItem("unsavedChanges")) === true)
      setShowConfirmationPopup(true);
    else {
      setShowConfirmationPopup(false);
      setResetFields(!resetFields);
      setEditMode(false);
      setSynced(false);
      setClicked(true);
    }
  };

  const handleOpenModal = (row) => {
    setTask(row?.task);
    // setProjectID(row?.ticket?.projectGuid);
    // setTaskName(row?.title);
    // setProjectName(row?.ticket?.project?.title);
    setShowModal(true);
  };

  const pagination = {
    rows,
    columns,
    order,
    setOrder,
    orderBy,
    setOrderBy,
    selected,
    defaultFilters,
    setDefaultFilters,
    setSelected,
    handleDeselect,
    search,
    setSearch,
    setPage,
    setRowsPerPage,
    numberRecords: numberOfRecords,
    page,
    rowsPerPage,
    fetchTableData,
    loading: loading || columnsWait,
    searchText: "timeEntry.list.search.label",
    refetch,
    tableMnemonic:
      // myTime || eID === true
      //   ?
      Mnemonic.Tables.OpenTimeEntries,
    // : Mnemonic.Tables.TimeEntries,
    timeEntryStatusesMnemonic: Mnemonic.TimeEntryStatuses,

    defaultFilters,
    deleteText: "timeEntry.list.delete.label",
    handleDelete: handleDelete,
    deleteLoading,
    readOnly: removeHeader,
    customButtons,
    handleOpenModal: myTime || eID ? handleOpenModal : null,
    linkCell: myTime || eID ? true : false,
    isFixed: true,
    removeRefresh: true,
    hideEditColumns: false,
    removeFilters: true,
    hideSearchBar: removeHeader,
    editButtonDisable: (row) =>
      !row.isEditable ||
      row.timeEntryStatus?.mnemonic === Mnemonic.TimeEntryStatuses.Approved ||
      row.synced,
      checkboxDisable: (row) =>
        row.timeEntryStatus?.mnemonic === 
          Mnemonic.TimeEntryStatuses.Rejected ,
        fromTimeEntryApproval:true
  };

  const handleAgree = () => {
    sessionStorage.removeItem("unsavedChanges");
    setShowConfirmationPopup(false);
    setResetFields(!resetFields);
    setEditMode(false);
    setSynced(false);
    setClicked(true);
  };

  return (
    <div>
      <>
      <MoveTimeEntryModal
          selectedTimeEntry={selected}
          setSelectedTimeEntry={setSelected}
          // parentTask={parentTask}
          openDialog={openMoveTaskDialog}
          handleClose={() => setOpenMoveTaskDialog(false)}
          refetechTask={() => refetchData()}
          changeNewlyOpen={openMoveTaskDialog}
          // handleFetchTree={handleFetchTree}
          // handleSelectFirstTask={handleSelectFirstTask}
          t={t}
        />
        {/* Rejection Reason Dialog */}
        <Dialog
          open={openRejectionReason}
          onClose={() => setOpenRejectionReason(false)}
          sx={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            "& .MuiDialog-paper": {
              maxHeight: "100% !important",
              minWidth: "600px !important", // Adjust width as needed
              padding: "6px 30px !important",
              backgroundColor: colors.grey_background,
              position: "absolute",
              top: "20%",
              left: "50%",
              transform: "translate(-50%, -20%)",
            },
          }}
        >
          <DialogTitle>{t("timeEntry.dialog.reason.label")}</DialogTitle>
          <DialogContent>
            <TextField
              fullWidth
              multiline
              rows={3}
              value={reason}
              onChange={(e) => setReason(e.target.value)}
              placeholder={t("timeEntry.dialog.reason")}
            />
          </DialogContent>
          <DialogActions>
            <IALoadingButton
              onClick={handleSubmit}
              style={{
                width: "150px",
                backgroundColor: dark_logo_blue,
                borderRadius: "50px",
                height: "36px",
              }}
              disabled={button3Subitting || selected.length == 0}
              loading={button3Subitting}
              label={t("timesheet.btn.reject.label")}
            />
          </DialogActions>
        </Dialog>
        <Dialog
          open={timesheet}
          onClose={handleCloseTimesheet}
          sx={{
            ".MuiDialog-paper": {
              maxHeight: "100% !important",
              minWidth: "1350px !important",
              padding: "6px 30px !important",
              backgroundColor: `${colors.grey_background}`,
            },
          }}
        >
    
          <Grid container alignItems="center">
            <Grid
              item
              sm={10}
              lg={10}
              md={10}
              xs={10}
              xl={10}
              p={2}
              sx={{ display: "flex", alignItems: "center" }}
            >
              <Grid item mr={1} sx={{ display: "flex", alignItems: "center" }}>
                {" "}
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  className="icon icon-tabler icon-tabler-chart-infographic"
                  width="22"
                  height="22"
                  viewBox="0 0 24 24"
                  strokeWidth="1.8"
                  stroke="#344767"
                  fill="none"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                >
                  <path stroke="none" d="M0 0h24v24H0z" fill="none" />
                  <path d="M7 7m-4 0a4 4 0 1 0 8 0a4 4 0 1 0 -8 0" />
                  <path d="M7 3v4h4" />
                  <path d="M9 17l0 4" />
                  <path d="M17 14l0 7" />
                  <path d="M13 13l0 8" />
                  <path d="M21 12l0 9" />
                </svg>
              </Grid>
              <Title style={{ marginTop: "5px" }}>{t("dialog.ts.title")}</Title>
            </Grid>
            <Grid
              item
              sm={2}
              lg={2}
              md={2}
              xs={2}
              xl={2}
              sx={{
                display: "flex",
                justifyContent: "flex-end",
                alignItems: "center",
              }}
            >
              <IconButton
                onClick={() => handleCloseTimesheet()}
                sx={{ fontSize: "14px !important" }}
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  className="icon icon-tabler icon-tabler-x"
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  strokeWidth="1"
                  stroke="#9e9e9e"
                  fill="none"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                >
                  <path stroke="none" d="M0 0h24v24H0z" fill="none" />
                  <path d="M18 6l-12 12" />
                  <path d="M6 6l12 12" />
                </svg>
              </IconButton>
            </Grid>
          </Grid>
          <Grid mt={-1} item pb={2}>
            <AttendanceByEmployee
              fromNav
              handleCloseTimesheet={handleCloseSubmitTimesheet}
              refetchData={refetchData}
              handleDate={(d) => setSelectedDate(d)}
            />
          </Grid>
        </Dialog>
        {(myTime || eID) && renderAddTime()}
        <TaskTabsModal
          showModal={showModal}
          setShowModal={(v) => setShowModal(v)}
          loading={loading}
          projectID={task?.ticket?.project?.projectGuid}
          projectName={task?.ticket?.project?.title}
          taskID={task?.taskGuid}
          taskName={task?.title}
          refetch={refetchData}
          fromProject={true}
          setType={(v) => (type.current = v)}
          type={task ? task.parentTaskGuid : type.current}
          open={JSON.parse(sessionStorage.getItem("unsavedChanges"))}
          modifyFormFlag={() =>
            sessionStorage.setItem("unsavedChanges", JSON.stringify(false))
          }
        />
        <TimeEntryDrawer
          PaperComponent={PaperComponent}
          openTimeEntryModal={clicked}
          setOpenTimeEntryModal={(v) => setClicked(v)}
          timeSheetGuid={null}
          timeEntryGuid={timeEntryGuid}
          description={timeEntry?.description}
          synced={synced}
          fromTimeEntriesList={true}
          refetchData={refetchData}
          refetchTasks={refetchTasks}
          refetchTask={refetchTask}
          handleFetchTree={handleFetchTree}
          handleDeselect={handleDeselect}
          fromProfile={eID ? true : false}
          editMode={editMode}
          handleEditMode={(v) => setEditMode(v)}
          handleChangeTimeEntryGuid={(v) => setTimeEntryGuid(v)}
          handleSetEmployeeGuid={(v) => setEmployeeGuid(v)}
          employees={employeesList}
          resetFields={resetFields}
          myTime={myTime}
          selectedTask={task}
          tasks={task_list}
          group={true}
          t={t}
          billable={billable}
        />
        <Grid container spacing={1}>
          {manageTimeEntry !== "N" && (
            <Grid
              item
              xs={14} sm={8} md={4} 
            >
              <AutoComplete
                multiple
                disableCloseOnSelect
                loading={employeeLoading}
                options={employeesList}
                getOptionLabel={(option) =>
                  option ? option.firstName + " " + option.lastName : ""
                }
                // renderOption={(props, option) => (
                //   <li {...props} key={uuidv4()}>
                //     {option.firstName + " " + option.lastName}
                //   </li>
                // )}
                identifier={"employeeGuid"}
                size="small"
                value={employeesValue}
                onOpen={() => setFetchEmployees(true)}
                onClose={() => setFetchEmployees(false)}
                onChange={(event, value) => {
                 
                  setEmployeesValue(value);

                  let tmp = [];
                  value.map((ids, inxex) => {
                    tmp.push(ids.employeeGuid);
                    return tmp;
                  });
             
                  setEmployeeIDs(tmp);
                }}
                sx={{
                  "& .MuiInputBase-input": { fontSize: "13px !important" },
                }}
                roundedTextField
                withPaperComponent={false}
                label={t("reports.label.employee")}
              />
            </Grid>
          )}

          <Grid item xs={14} sm={8} md={4}>
            <AutoComplete
              multiple
              disableCloseOnSelect
              loading={projectLoading}
              options={projectsList}
              getOptionLabel={(option) => (option ? option.title : "")}
              // renderOption={(props, option) => (
              //   <li {...props} key={uuidv4()}>
              //     {option.title}
              //   </li>
              // )}
              identifier={"projectGuid"}
              size="small"
              value={projectsValue}
              onOpen={() => setFetchProjects(true)}
              onClose={() => setFetchProjects(false)}
              onChange={(event, value) => {
                setProjectsValue(value);
                let tmp = [];
                value.map((ids, inxex) => {
                  tmp.push(ids.projectGuid);
                  return tmp;
                });
                setProjectIDs(tmp);
              }}
              sx={{
                "& .MuiInputBase-input": { fontSize: "13px !important" },
              }}
              label={t("reports.label.projects")}
              roundedTextField
              withPaperComponent={false}
            />
          </Grid>
          <Grid item xs={14} sm={8} md={4}>
             </Grid>
          <Grid item xs={12} sm={6} md={2}>
            <AutoComplete
              multiple
              disableCloseOnSelect
              loading={statusesWait}
              options={statusesList}
              getOptionLabel={(option) => (option ? option.description : "")}
              // renderOption={(props, option) => (
              //   <li {...props} key={uuidv4()}>
              //     {option.description}
              //   </li>
              // )}
              withPaperComponent={false}
              identifier={"timeEntryStatusGuid"}
              size="small"
              value={statusesValue}
              onOpen={() => setFetchStatuses(true)}
              onClose={() => setFetchStatuses(false)}
              onChange={(event, value) => {
                setStatusesValue(value);
                let tmp = [];
                value.map((ids, inxex) => {
                  tmp.push(ids.timeEntryStatusGuid);
                  return tmp;
                });

                setStatusIDs(tmp);
              }}
              sx={{
                "& .MuiInputBase-input": { fontSize: "13px !important" },
              }}
              label={t("timeEntry.filters.Status")}
              roundedTextField
            />
          </Grid>

          <Grid item xs={12} sm={4} md={3} lg={2} xl={2}>
            <RoundedDatePicker
              className="date_picker_styles"
              label={t("projectDashboard.label.DateFrom")}
              value={dateFrom}
              disableFuture
              onChange={(newValue) => {
                setDateFrom(newValue);
                setDateVal(data_filter.find((x) => x.mnemonic === "custom"));
              }}
              onClose={() => setOpen(true)}
            />
          </Grid>
          <Grid item xs={12} sm={4} md={3} lg={2} xl={2}>
            <RoundedDatePicker
              className="date_picker_styles"
              label={t("projectDashboard.label.DateTo")}
              value={dateTo}
              // disableFuture
              shouldDisableDate={disableDates}
              autoFocus={open}
              open={open}
              onClose={() => setOpen(false)}
              onClick={() => setOpen(!open)}
              onOpen={() => setOpen(!open)}
              onChange={(newValue) => {
                handleValidateDates(
                  timer,
                  setTimer,
                  dateFrom,
                  newValue,
                  setDateTo,
                  enqueueSnackbar,
                  t
                );
                setDateVal(data_filter.find((x) => x.mnemonic === "custom"));
              }}
              // renderInput={(params) => (
              //   <RoundedTextField removeMinWidth {...params} />
              // )}
            />
          </Grid>
          <Tooltip title={t("tooltip.PreviousPeriod")}>
            <Grid item sx={{ display: "flex", alignItems: "center" }}>
              <PreviousIcon
                color={dateVal.mnemonic === "custom" ? "#73717380" : "#737173"}
                onClick={() => {
                  if (dateVal.mnemonic !== "custom")
                    handleDateBackward(
                      dateFrom,
                      dateTo,
                      dateVal,
                      setDateFrom,
                      setDateTo
                    );
                }}
              />
            </Grid>
          </Tooltip>
          <Grid item xs={12} sm={4} md={2} lg={1.5} xl={1.5}>
            <Autocomplete
               id="date"
      
              options={data_filter}
              getOptionLabel={(option) => (option ? t(option.name) : "")}
              // renderOption={(props, option) => (
              //   <li {...props} key={uuidv4()}>
              //     {t(option.name)}
              //   </li>
              // )}
              isOptionEqualToValue={(option, value) =>
                value == "" || option.mnemonic === value.mnemonic
              }
              size="small"
              disableClearable
              value={dateVal}
              onChange={(event, value) => {
                setDateVal(value);
                handleTimeBetween(value.mnemonic, setDateFrom, setDateTo);
              }}
              fullWidth
          //    PaperComponent={(props) => <AutoCompletePaper {...props} />}
              renderInput={(params) => (
                <RoundedTextField
                  label={t("dateFilter.label")}
                  size="small"
                  removeMinWidth
                  {...params}
                />
              )}
              sx={{ ".MuiInputBase-input": { fontSize: "14px !important" } }}
            />
          </Grid>
          <Tooltip title={t("tooltip.NextPeriod")}>
            <Grid item sx={{ display: "flex", alignItems: "center" }}>
              <NextIcon
                color={dateVal.mnemonic === "custom" ? "#73717380" : "#737173"}
                onClick={() => {
                  if (dateVal.mnemonic !== "custom")
                    handleDateForward(
                      dateFrom,
                      dateTo,
                      dateVal,
                      setDateFrom,
                      setDateTo
                    );
                }}
              />
            </Grid>
          </Tooltip>
        </Grid>
        {!getColumnsLoading && (
          <DataTable
            {...pagination}
            //withSideInfo={myTime}
           // sideInfoData={sideInfoData}
            expandCollapse={true}
            identifier={"timeEntryGuid"}
            fromEmployee={eID ? true : false}
            hasCheckbox={!removeCheckbox}
            hasTansparentBackground={modal === true}
            heightClassName={ "table-time-entry-approval-height" }
            showNbSelectedRowOnTop={true}
            // checkForCheckbox={(row) => {
            //   return (
            //     ((row?.employee?.directManagerGuid === storeUserGuid
            //        &&
            //       isManager &&
            //       manageTimeEntry === "M") || row?.employee?.employeeGuid === storeUserGuid ||
            //       isAdmin)
            //   );
            // }}
          />
        )}
      </>
      {/* )} */}
    </div>
  );
}

export default TimeEntryRequestsList;
